import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface FooterWidgetProps {}

export const FooterWidget: React.FC<FooterWidgetProps> = (props) => {
  return (
    <S.Container>
      <S.Row>
        <S.Text>
          <S.Link href="https://foxbun.industries">foxbun.industries</S.Link>
        </S.Text>
        <S.Text>Copyright {new Date().getFullYear()}</S.Text>
      </S.Row>
      <S.Row>
        <S.Text>Terms and conditions</S.Text>
        <S.Text>Privacy policy</S.Text>
      </S.Row>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    width: 300px;
    margin: auto;
  `;

  export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
  `;

  export const Text = styled.div`
    font-family: ${Font.Special};
    color: ${(p) => p.theme.text.secondary};
    font-size: 13px;
  `;

  export const Link = styled.a`
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:hover {
      color: ${(p) => p.theme.text.primary};
    }
  `;
}
